import React from 'react'

const CorporateLogo5: React.FC = () => {
  return (
    <img style={{position: "relative", height: "100%", pointerEvents: "none", userSelect: "none"}} src="/svgs/corporate_logo5.svg" alt="corporate_logo5"/>
  )
}

export default CorporateLogo5